import { match } from 'ts-pattern';
export const migrateToV4 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'Deck'
        }, (deck)=>({
                ...deck,
                fixingSystem: deck.fixingSystem === 'FlipLock' ? 'ToggleLock' : deck.fixingSystem
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v4.js.map